define('views/modules/conversation/message/message-list-item',[
    // Libs
    'jquery', 'underscore', 'backbone', 'mustache', 'utils', 'toastr',
    // services
    'services/user',
    'services/events/calendar-events',
    'services/events/conversation-events',
    'services/session',
    'services/i18n',
    'services/mobile-download',
    'services/api',
    'services/platform.service',
    // views
    'views/parts/menu/menu-context',
    'views/modules/supervisor/supervisor-icon',
    'views/parts/form/button',
    'views/modules/conversation/message/reply-list',
    'views/modules/calendar/calendar/calendar-component/item/calendar-item-list',
    'views/modules/questionnaire/responses/response-panel',
    'views/modules/modal/thumbnail-modal',
    // collections
    'collections/conversation/messages',
    'collections/calendar/items',
    // models
    'models/questionnaire/questionnaire',
    'models/questionnaire/response',
    // templates
    'text!templates/modules/conversation/message/message-list-item.html',
], function(
    // Libs
    $, _, Backbone, Mustache, U, Toastr,
    // services
    User,
    CalendarEvents,
    ConversationEvents,
    Session,
    i18n,
    MobileDownload,
    API,
    PlatformService,
    // views
    VMenuContext,
    VSupervisorIcon,
    VButton,
    VReplyList,
    VCalendarItemList,
    VResponsePanel,
    VThumbnailModal,
    // collections
    CMessages,
    CCalendarItems,
    // models
    MQuestionnaire,
    MResponse,
    // templates
    TMessageListItem
) {

    var VMessageListItem = Backbone.Epoxy.View.extend({
        template: TMessageListItem,
        events: {
            "click .options-toggle": "showMenuOptions",
            "click": "onClick",
            "click .attachment-info a.mobile": "onAttachmentLinkClick", // Click on an attachment link
            "click a": "onLinkClick",
            "click img": "onImageClick"
        },
        regions: {
            menu: ".menu-options",
            supervisorIcon: ".supervisor-icon",
            messageBox: ".message-box",
            replyButton: ".button-reply",
            replyList: ".reply-list",
            itemList: '.calendar-items',
            questionnaireAnswerButton: ".button-questionnaire-answer",
        },

        initialize: function(opt) {
            this.options = opt || {};

            var model = this.model,
                conversation = this.conversation = opt.conversation,
                activity = this.activity = new CCalendarItems(model.getActivity()),
                replies = this.replies = new CMessages(model.getReplies(), {
                    conversation: conversation,
                    users: conversation.getComputedUsers()
                });

            if (replies.length) {
                replies.prepareCollection();
            }

            _.extend(this, {
                view: {
                    replyButton: new VButton({
                        label: "calendar:Reply to this feedback",
                        callback: this.onFeedbackReply,
                        icon: "fa fa-reply",
                        tcClass: false,
                        class: "btn-sm btn-default",
                        context: this
                    }),
                    replyList: new VReplyList({
                        collection: replies,
                        supervisors: opt.supervisors,
                        conversation: opt.conversation
                    }),
                    itemList: new VCalendarItemList({
                        collection: activity,
                        url: Mustache.render('#/' + this.options.url.calendar, {
                            conversationId: conversation.id,
                            groupId: this.options.group.id,
                            userId: this.options.profile.id
                        }),
                        role: this.options.role
                    }),
                    questionnaireAnswerButton: new VButton({
                        label: "conversation:view_questionnaire_response",
                        callback: this.onViewQuestionnaireAnswer,
                        icon: "fa fa-eye",
                        tcClass: false,
                        class: "btn-sm btn-default",
                        context: this
                    }),
                },
                timestamp: model.getTimeStampObject(),
                conversation: opt.conversation,
                supervisors: opt.supervisors
            });

            this.panel = {};

            this.listenTo(model, {
                'active': this.setActive,
                'remove': this.remove,
                'reply:success': this.onReplySuccess
            });

            var attachments = this.model.getAttachments();
            
            if(attachments && attachments.length > 0) {
                attachments.forEach(function(attachment) {
                    this.downloadAttachment(attachment);
                }, this);
            }
        },

        render: function() {
            this.initListener();
            var model = this.model;

            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext(_.extend(this.model.toJSON(), {
                isSupervisor: this.userIsSupervisor(),
                isReply: Boolean(model.get('parentId')),
                isConnectedUser: model.getUser() === User.id,
                isMobile: PlatformService.isMobile()
            })), {
                date: this.getTemplatedTimestamp(),
            }));

            this.generateZones();

            var view = this.view,
                zone = this.zone;

            if (view.menu) {
                this.assign(view.menu, zone.$menu);
            }

            if (model.getActivity()) {
                this.assign(view.replyButton, zone.$replyButton);
            }

            if (model.isQuestionnaireResponse()) {
                this.assign(view.questionnaireAnswerButton, zone.$questionnaireAnswerButton);
            }

            this.assign(view.replyList, zone.$replyList)
                .assign(view.itemList, zone.$itemList);

            this.renderSupervisorIcon();

            this.applyBindings();

            return this;
        },

        initListener: function() {
            this.stopListeningTo(CalendarEvents);
            this.listenTo(CalendarEvents, {
                'item:destroy': this.onItemDestroy,
            });
        },

        renderSupervisorIcon: function() {
            var view = this.view;
            if (this.userIsSupervisor()) {
                var supervisorIcon = view.supervisorIcon || (view.supervisorIcon = new VSupervisorIcon());
                this.assign(supervisorIcon, this.zone.$supervisorIcon);
            }
        },

        showMenuOptions: function(e) {
            e.preventDefault();
            var view = this.view.menu;
            if (!view) {
                this.view.menu = view = new VMenuContext({
                    context: this,
                    onClick: this.onActionClick,
                    collection: new Backbone.Collection([
                        { caption: "Delete", icon: "sl-icon-trash", callback: this.onDelete }
                    ]),
                });
                this.assign(view, this.zone.$menu);
            }
            view.toggle();
        },

        downloadAttachment: function(attachment) {
            var messageItem = this;

            $.ajaxTransport("+binary", function(options, originalOptions, jqXHR) {
                // check for conditions and support for blob / arraybuffer response type
                if (window.FormData &&
                    options.dataType && options.dataType === 'binary' ||
                    options.data && window.ArrayBuffer && options.data instanceof ArrayBuffer ||
                    window.Blob && options.data instanceof Blob) {
                    return {
                        // create new XMLHttpRequest
                        send: function(headers, callback) {
                            // setup all variables
                            var xhr = new XMLHttpRequest(),
                                url = options.url,
                                type = options.type,
                                async = options.async || true,
                                // blob or arraybuffer. Default is blob
                                dataType = options.responseType || "blob",
                                data = options.data || null,
                                username = options.username || null,
                                password = options.password || null;

                            xhr.addEventListener('load', function() {
                                var data = {};
                                data[options.dataType] = xhr.response;
                                // make callback and send data
                                callback(xhr.status, xhr.statusText, data, xhr.getAllResponseHeaders());
                            });

                            xhr.open(type, url, async, username, password);

                            // setup custom headers
                            for (var i in headers) {
                                if (headers.hasOwnProperty(i)) {
                                    xhr.setRequestHeader(i, headers[i]);
                                }
                            }

                            xhr.responseType = dataType;
                            xhr.send(data);
                        },
                        abort: function() {
                            jqXHR.abort();
                        }
                    };
                }
            });

            var options = {
                url: attachment.url,
                method: "get",
                dataType: "binary",
                // processData: false,
            };

            return $.ajax(options).then(function(data) {
                var binaryData = [];
                binaryData.push(data);

                var blob = new Blob(binaryData, { type: "image/jpeg" });
                var urlCreator = window.URL || window.webkitURL;
                var imageUrl = urlCreator.createObjectURL(blob);

                attachment.image = imageUrl;
                attachment.url = imageUrl;
                messageItem.render();
            });
        },

        getTemplatedTimestamp: function() {
            return Mustache.render('<span title="{{timestamp}}">{{fromNow}}</spam>', {
                fromNow: this.timestamp.fromNow(),
                timestamp: this.timestamp.local()
            });
        },

        userIsSupervisor: function() {
            return Boolean(this.supervisors.get(this.model.getUser()));
        },

        checkForNewReply: function() {
            var messages = this.conversation.getMessages({ collection: true }),
                messageModel = messages.get(this.model);

            if (messageModel.getReplies().length !== this.replies.length) {
                this.replies.add(messageModel.getLastReply());
            }
        },

        isActive: function() {
            return this.zone.$messageBox.hasClass('active');
        },

        setActive: function(val) {
            this.zone.$messageBox.toggleClass('active dark-color', val);
        },

        saveAttachment: function() {
            var attachment = this.model.get('attachments')[0];
            MobileDownload.download(attachment.file, attachment.name, attachment.mimeType);
        },

        getResponsePanel: function(questionnaireId) {
            var view = this.panel,
                panel = view.response,
                questionnairesModel = new MQuestionnaire({ id: questionnaireId });
                questionnairesModel.fetch();

            if (!panel) {
                panel = view.response = new VResponsePanel({
                    questionnaire: questionnairesModel,
                    group: this.group,
                });
                this.listenTo(panel, {
                    'questionnaire:post': this.onQuestionnairePost,
                    'questionnaire:link': this.onQuestionnaireLink
                });
            }
            return panel;
        },

        ////////////
        // actions //
        ////////////
        onActionClick: function(e, item, menu) {
            e.preventDefault();
        },

        ////////////
        // events //
        ////////////

        onReplySuccess: function(conversation) {
            this.conversation = conversation;
            this.checkForNewReply();
        },

        onDelete: function() {
            var self = this;
            Backbone.ajax({
                method: 'DELETE',
                url: API.url('conversations/' + this.conversation.id + '/messages/' + this.model.id),
                success: function() {
                    self.$el.slideUp(400);
                },
                error: function() {
                    console.log('Can not delete message');
                }
            })
        },

        onClick: function() {
            this.model.trigger('message:click', this.model);
        },

        onLinkClick: function(e) {
            // Open in system browser on native platforms
            if (window.Capacitor && window.Capacitor.isNativePlatform()) {
                e.preventDefault();
                window.open(encodeURI(e.target.href), '_system');
            }
            return true;
        },

        onAttachmentLinkClick: function(e) {
            e.preventDefault();
            e.stopPropagation();
            // Capacitor Filesystem plugin handles permissions automatically
            this.saveAttachment();
        },

        onFeedbackReply: function() {
            this.setActive(true);
            this.model.trigger('feedback:reply', this.model);
        },

        onViewQuestionnaireAnswer: function() {
            var typeReferences = _.object(['questionnaireId', 'responseId'], this.model.getTypeReference().split(':'));
            var responseModel = new MResponse({ id: typeReferences.responseId });

            var panel = this.getResponsePanel(typeReferences.questionnaireId);
            panel.setUser(this.model.getUser());
            panel.setModel(responseModel);

            ConversationEvents.showQuestionnaireResponse(panel);
        },

        onItemDestroy: function(id) {
            var activityCollection = this.activity;
            if (activityCollection.length && activityCollection.first().id === id) {
                activityCollection.remove(id);
            }
        },

        onDisable: function() {
            this.stopListeningTo(CalendarEvents);
        },

        onImageClick: function(e) {
            // Find correct attachment based on it's name
            var attachment = this.model.get("attachments").find(function(att) {
                return att.name == e.currentTarget.name;
            }, this);
            
            if(!attachment) {
                return;
            }

            (new VThumbnailModal(attachment.image, attachment.name)).render();
        }

    });

    return VMessageListItem;
});

